import _Person from "@material-ui/icons/esm/Person";
import _ChatBubble from "@material-ui/icons/esm/ChatBubble";
import _IconButton from "@material-ui/core/esm/IconButton";
import _Typography from "@material-ui/core/esm/Typography";
import _Box from "@material-ui/core/esm/Box";
import _Badge from "@material-ui/core/esm/Badge";
import _Avatar from "@material-ui/core/esm/Avatar";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import { useStyles } from "./UserStyles";
import { useMessenger } from "../../../Messenger";
import { useUsers } from "../../hooks/useUsers";
import { useNotifications } from "../../../Notifications";

var _ref3 = /*#__PURE__*/_jsx(_Person, {});

const User = _ref => {
  let user = _ref.user;
  const classes = useStyles();

  const _useMessenger = useMessenger(),
        handleOpenChat = _useMessenger.handleOpenChat,
        selectedChat = _useMessenger.selectedChat,
        userSideDrawer = _useMessenger.userSideDrawer;

  const _useUsers = useUsers(),
        connectedUsers = _useUsers.connectedUsers;

  const _useNotifications = useNotifications(),
        notifications = _useNotifications.notifications;

  const isConnected = connectedUsers.contacts?.some(_ref2 => {
    let id = _ref2.id;
    return id === user.id;
  });
  const hasNewMessages = notifications.some(notification => notification.id === user.id);
  return _jsx(_Box, {
    display: "flex",
    className: "".concat(classes.container, " ").concat(user.id === selectedChat?.id && 'active'),
    onClick: () => handleOpenChat(user)
  }, void 0, _jsx(_Box, {
    display: "flex",
    alignItems: "center",
    className: classes.avatarContainer
  }, void 0, _jsx(_Badge, {
    className: classes[isConnected ? 'availableStatus' : 'unavailableStatus'],
    badgeContent: " ",
    overlap: "circle",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, void 0, _jsx(_Avatar, {
    src: user.avatar,
    alt: "Activity",
    className: classes.avatar
  }))), _jsx(_Box, {
    flexGrow: 1
  }, void 0, _jsx(_Box, {
    display: "flex"
  }, void 0, _jsx(_Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, void 0, _jsx(_Typography, {
    variant: "body1",
    color: "secondary",
    className: classes.fontWeightBold
  }, void 0, user.name || user.email), user.name && user.email && _jsx(_Typography, {
    color: "secondary",
    variant: "body2",
    className: classes.fontWeightBold
  }, void 0, user.email), user.position && _jsx(_Typography, {
    color: "secondary",
    variant: "body2",
    className: classes.fontWeightBold
  }, void 0, user.position), user.company && _jsx(_Typography, {
    color: "secondary",
    variant: "body2",
    className: classes.fontWeightBold
  }, void 0, user.company)))), _jsx(_Box, {
    display: "flex",
    alignItems: "center"
  }, void 0, _jsx(_Box, {}, void 0, _jsx(_IconButton, {
    onClick: event => {
      userSideDrawer.handleShow(user);
      event.stopPropagation();
    }
  }, void 0, _ref3)), _jsx(_Box, {}, void 0, _jsx(_IconButton, {}, void 0, _jsx(_Badge, {
    color: "primary",
    invisible: !hasNewMessages,
    className: classes.notificationBadge
  }, void 0, _jsx(_ChatBubble, {
    className: classes.messageIcon
  }))))));
};

export { User };